
import numeral from 'numeral'

/**
 * Отправка статистики по отображаемым спискам лотов для поиска
 * @param {object[]} lots 
 * @param {object[]} fixedpricelots 
 */
export const sendViewSearchList = (lots, fixedpricelots) => {
    let impressions = {};

    for (let i = 0; i < lots.length; i++) {
        const item = {
            'name': lots[i].title,
            'id': lots[i]._id,
            'price': numeral(lots[i].price || lots[i].nextBid).format('0.00').replace(/\,/g, "."),
            'brand': 'meetforcharity',
            'category': (lots[i].isLottery) ? 'Лотереи' : ((lots[i].price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
            'variant': '',
            'list': 'Поиск',//'Главная страница',
            'position': i + 1
        }
        if (!impressions[lots[i].currency._id])
            impressions[lots[i].currency._id] = [item]; else
            impressions[lots[i].currency._id].push(item)
    }

    for (let i = 0; i < fixedpricelots.length; i++) {
        const item = {
            'name': fixedpricelots[i].title.toString(),
            'id': fixedpricelots[i]._id,
            'price': numeral(fixedpricelots[i].price || fixedpricelots[i].nextBid).format('0.00').replace(/\,/g, "."),
            'brand': 'meetforcharity',
            'category': (fixedpricelots[i].isLottery) ? 'Лотереи' : ((fixedpricelots[i].price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
            'variant': '',
            'list': 'Поиск',
            'position': i + 1
        }
        if (!impressions[fixedpricelots[i].currency._id])
            impressions[fixedpricelots[i].currency._id] = [item]; else
            impressions[fixedpricelots[i].currency._id].push(item)
    }

    for (let key in impressions) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            pageType: 'category',
            'ecommerce': {
                'currencyCode': key,
                'impressions': impressions[key]
            },
            'event': 'ee-event',
            'ee-event-category': 'enhanced ecommerce',
            'ee-event-action': 'product impressions',
            'ee-event-non-interaction': 'True',
        });
    }
}


/**
 * Отправка статистики по отображаемым спискам лотов
 * @param {string[]} keysDiff 
 * @param {string[]} keys 
 * @param {object} items 
 * @param {string} listName 
 */
export const sendViewLotsList = (keysDiff, keys, items, listName) => {
    window.dataLayer = window.dataLayer || [];
    let currencies = {};
    keysDiff.map(key => {
      const item = {
        'name': items[key].title,
        'id': key,
        'price': numeral(items[key].price || items[key].nextBid).format('0.00').replace(/\,/g, "."),
        'brand': 'meetforcharity',
        'category': (items[key].isLottery) ? 'Лотереи' : ((items[key].price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
        'variant': '',
        'list': listName,
        'position': keys.indexOf(key)+1
        }
      currencies[items[key].currency._id] 
      ? currencies[items[key].currency._id].push(item)
      : currencies[items[key].currency._id] = [item]
    })

    for (let currency in currencies) {
      window.dataLayer.push({
        pageType: 'category',
        'ecommerce': {
        'currencyCode': currency,
        'impressions': currencies[currency]
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'product impressions',
        'ee-event-non-interaction': 'True',
      })
    }
}



/**
 * отправка в менеджер тегов списка отображаемых лотов
 * @param {lot/fixpricelot[]} lots 
 * @param {string} listName 
 */
export const sendViewCard = (lots, listName) => {
    let currencies = {};

    for (let i = 0; i < lots.length; i++ ) {
    const item = {
      'name': lots[i].title,
      'id': lots[i]._id,
      'price': numeral(lots[i].price || lots[i].nextBid).format('0.00').replace(/\,/g, "."),
      'brand': 'meetforcharity',
      'category': (lots[i].isLottery) ? 'Лотереи' : ((lots[i].price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
      'variant': '',
      'list': listName,
      'position': i+1
    }
      if (!currencies[lots[i].currency._id])
      currencies[lots[i].currency._id] = [item]; else
      currencies[lots[i].currency._id].push(item)
    }
  
   for (let key in currencies){
     window.dataLayer = window.dataLayer || [];
     window.dataLayer.push({
       pageType: 'category',
       'ecommerce': {
       'currencyCode': key,
       'impressions': currencies[key]
     },
     'event': 'ee-event',
     'ee-event-category': 'enhanced ecommerce',
     'ee-event-action': 'product impressions',
     'ee-event-non-interaction': 'True',
     });
   }
  }


/**
 * отправка в менеджер тегов лота, на который кликнул пользователь
 * @param {lot/fixpricelot} lot 
 * @param {string} listName 
 * @param {number} position 
 */
export const sendClickCard = (lot, listName, position) => {
    let title = ''
    if (lot.title ) lot.title.map((el, i) => {
        if (el.props.children) title += ((i + 1 == lot.title.length) ? el.props.children[1] : el.props.children[1] + ' ')
    })

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'ecommerce': {
        'currencyCode': lot.currency._id,
        'click': {
            'actionField': {'list': listName},
            'products': [{
                'name': (lot.title && typeof lot.title === 'string') ? lot.title : (title || ''),
                'id': lot._id,
                'price': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                'brand': 'meetforcharity',
                'category': (lot.isLottery) ? 'Лотереи' : ((lot.price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
                'variant': '',
                'position': position
            }]
        }
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'product clicks',
        'ee-event-non-interaction': 'False',
    });

}

/**
 * отправка в менеджер тегов лота, страницу которого просмотрел пользователь
 * @param {lot/fixpricelot} lot 
 * @param {string} listName 
 */
 export const sendViewLot = (lot, listName = "") => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'pageType': 'product',
        'ecommerce': {
        'currencyCode': lot.currency._id,
        'detail': {
            'actionField': {'list': listName || ""},
            'products': [{
                'name': lot.name,
                'id': lot._id,
                'price': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                'brand': 'meetforcharity',
                'category': (lot.isLottery) ? 'Лотереи' : ((lot.price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
                'variant': ''
            }]
        }
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'product details',
        'ee-event-non-interaction': 'True',
    });
}

/**
 * 4 Add to cart / Клик на «Сделать ставку»/«Оставить заявку»
 * @param {lot/fixpricelot} lot 
 * @param {string} listName 
 * @param {number} quantity - количество 
 */
 export const sendAddToCart = (lot, listName = "", quantity = 1) => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'ecommerce': {
            'currencyCode': lot.currency._id,
            'add': {
                'actionField': {'list': listName || ""},
                'products': [{
                    'name': lot.name,
                    'id': lot._id,
                    'price': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                    'brand': 'meetforcharity',
                    'category': (lot.isLottery) ? 'Лотереи' : ((lot.price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
                    'variant': '',
                    'quantity': quantity
                }]
            }
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'add to cart',
        'ee-event-non-interaction': 'False',
    });
}

/**
 * 5 Checkout Step 1 / Выбор способа оплаты / Ввод контактных данных
 * При открытии страницы выбора способа оплаты лота или при открытии формы заявки на лот должен отправляться массив ecommerce.checkout
 * @param {lot/fixpricelot} lot 
 * @param {number} quantity - количество 
 */
 export const sendCheckout = (lot, quantity = 1) => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'pageType': 'cartpage',
        'ecommerce': {
            'currencyCode': lot.currency._id,
            'checkout': {
                'actionField': {'step': 1},
                'products': [{
                    'name': lot.name,
                    'id': lot._id,
                    'price': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                    'brand': 'meetforcharity',
                    'category': (lot.isLottery) ? 'Лотереи' : ((lot.price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
                    'variant': '',
                    'quantity': quantity
                }]
            }
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'checkout step 1',
        'ee-event-non-interaction': 'False',
    });
}

/**
 * 6 Purchase / Оплата лота / Отправка заявки на лот
 * Только по успешной отправке заявки, по оплате - на беке
 * @param {lot/fixpricelot} lot 
 * @param {number} quantity - количество 
 */
 export const sendRequestTM = (lot, quantity = 1) => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'ecommerce': {
            'currencyCode': lot.currency._id,
            'purchase': {
                'actionField':  {
                    'id': '',//???
                    'affiliation': 'meetforcharity.ru',
                    'revenue': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                    'tax': '0.00',
                    'shipping': '0.00',
                    'coupon': ''
                },
                'products': [{
                    'name': lot.name,
                    'id': lot._id,
                    'price': numeral(lot.price || lot.nextBid).format('0.00').replace(/\,/g, "."),
                    'brand': 'meetforcharity',
                    'category': (lot.isLottery) ? 'Лотереи' : ((lot.price) ? 'Лоты с фиксированной ценой' : 'Аукционы'),
                    'variant': '',
                    'quantity': quantity,
                    'coupon': ''
                }]
            }
        },
        'event': 'ee-event',
        'ee-event-category': 'enhanced ecommerce',
        'ee-event-action': 'purchase',
        'ee-event-non-interaction': 'False',
    });
}
//export default sendViewCard


// WEBPACK FOOTER //
// ./src/helpers/tagManager.js